import React from "react";
import { motion } from "framer-motion";

const AboutPage = () => {
  return (
    <motion.div
      initial={{ x: -1000 }}
      animate={{ x: 0 }}
      transition={{ duration: 0.5, ease: "linear" }}
      className="my-10"
    >
      <h1 className="text-4xl text-gray-700 font-bold text-center">About Us</h1>
      <img
        src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FIMG_3955.jpg?alt=media&token=d05ee36e-7e9e-46a8-b3db-de16958a199b"
        className="rounded-xl w-96 mx-auto my-5 shadow-lg"
        alt=""
      />
      <p className="text-center text-xl text-gray-500 tracking-widest">
        Computer, Mobile Phones, Point of Sales Devices, Digital Gadgets and
        other accessories shop
      </p>
    </motion.div>
  );
};

export default AboutPage;
